export default {
    email: 'Adresse courriel',
    phone: 'Numéro de téléphone',
    cellphone: 'Numéro de téléphone mobile',
    virtual_account: 'Nom d\'utilisateur lors de l\'évènement vidéo',
    reacts_event_url: 'Lien de l\'évènement vidéo',
    reacts_event_id: 'Numéro de l\'évènement vidéo',
    resident_room_number: 'Si connu, numéro de la chambre de la personne à contacter',
    ah635_health_problems_question: 'Problèmes de santé actuels',
    ah635_immunosuppression_question: 'Immunodépression',
    ah635_allergic_reactions_question: 'Réaction allergique',
    ah635_pregnancy_question: 'Grossesse',
    ah635_bleeding_disorder_question: 'Trouble de la coagulation',
    ah635_immunization_question: 'Produits immunisants ou sanguins',
    influenza_health_status: 'Est-ce que l’une des situations suivantes s\'applique à vous ?',
    influenza_is_immunosuppressive: 'Êtes-vous dans l’une des deux situations suivantes ?',
    influenza_has_severe_reaction: 'Avez-vous déjà fait une réaction importante après avoir reçu un vaccin ou un autre produit ayant nécessité une visite à l’hôpital ?',
    influenza_is_pregnant: 'Si vous êtes une femme, êtes-vous présentement enceinte ?',
    influenza_received_vaccine_last_month: 'Avez-vous reçu un vaccin au cours du dernier mois ?',
    influenza_has_immunocompromised_contact: 'Êtes-vous en contact étroit avec une personne immunodéprimée ?',
    influenza_people_who_live_with_me: 'Vivez-vous avec un enfant de moins de 6 mois, une personne de 75 ans et plus, une femme enceinte au 2e ou 3e trimestre ou avec une personne atteinte d’une maladie chronique ?',
    influenza_has_blood_transfusion: 'Avez-vous reçu une transfusion sanguine ou des immunoglobulines au cours des 11 derniers mois ?',
    influenza_received_pneumococcal_vaccine: 'Avez-vous déjà reçu un vaccin contre le pneumocoque ?',
    influenza_is_health_care_worker: 'Êtes-vous un travailleur de la santé ?',
    influenza_received_shingles_vaccine: 'Avez-vous déjà reçu un vaccin contre le zona ?',
    phx_covid_screening_reason: 'Raison du dépistage de la COVID-19',
    phx_covid_screening_details_consent: 'Je consens aux détails du test de dépistage contre la COVID-19',
    phx_covid_screening_consent: 'Je consens au test de dépistage contre la COVID-19',
    phx_covid_accept_risk: 'En cochant cette case, je reconnais avoir lu et compris les informations et j’accepte les limites et les risques associés au test rapide.',
    covid_screening_student_level: 'Niveau scolaire',
    as624_health_problems_question: 'Problèmes de santé actuels',
    as624_immunosuppression_question: 'Immunodépression',
    as624_allergic_reactions_question: 'Réaction allergique',
    as624_bleeding_disorder_question: 'Trouble de la coagulation',
    as624_has_blood_transfusion_question: 'Transfusion sanguine ou une injection d’immunoglobulines',
    as624_pregnancy_question: 'Grossesse',
    as624_less_than_six_months_mother_treatment_question: 'Patient de moins de six mois mère de traitement pendant la grossesse',
    phone_extension: 'Extension téléphonique',
    sendConfirmationSms: 'Confirmation SMS',
    confirmEmail: 'Confirmation courriel',
    traveler_ramq: 'RAMQ du voyageur',
    traveler_birthdate: 'Date de naissance du voyageur',
    travel_departure_date: 'Date prévue du voyage',
    traveler_first_name: 'Prénom du voyageur',
    traveler_last_name: 'Nom du voyageur',
    traveler_age: 'Âge du voyageur ',
    traveler_status: 'Statut du voyageur',
    recaptcha: 'Je ne suis pas un robot',
    terms_agreement: 'Termes et conditions',
    delegate_consent: 'Consentement délégué',
    received_communication_consent: 'Consentement à recevoir des communications',
    privacy_policy_agreement: 'Politique de confidentialité',
    'nam-expiration-date': 'Date d\'expiration de la carte d\'assurance maladie',
    'nam-sequential': 'Numéro séquentiel de la carte d\'assurance maladie',
};
